function Page404() {
    return (
        <div style={{textAlign:'center'}}>
            <h1>404</h1>
            <h3>Page Not Found</h3>
        </div>
    )
}

export default Page404;